import React,{useState,useEffect} from 'react';
import "./loran.css"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Creater.css"
import "./more_nft.css"
import Fotter from '../../Home/Home_modules/Footerr/footer'
import './nftdetail.css'
import './popup.css';
import firebase from 'firebase/compat/app';
import ShareButton from "react-web-share-button";
import { useParams } from "react-router-dom";
import { ethers } from 'ethers'
import Web3Modal from 'web3modal'
import { nftaddress, nftmarketaddress} from '../../contrast/config'

import NFT from '../../contrast/NFT.sol/NFT.json'
import './loader.css'
import axios from 'axios'
import Web3 from 'web3'
import './dropdown.css'
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnectProvider from "@walletconnect/web3-provider";



const divStyle = {
    borderColor: '#ffffff',
    backgroundColor:'#ffffff',
};
const walletaddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT');

export default function Nftshowcase(){
    const  nftId  = useParams();
    //console.log(nftId)
    const [NFTData, setNFData] = useState([]);
   
    const [tokenId, setTokenId] = useState('');
    const [ docId, setDocId] = useState(''); 
    const [ auctionId, setAuctionId] = useState('');
    const [ listingId, setListingId] = useState('');

    
    useEffect(() => {
        const nftRef = firebase.firestore().collection('NFTs').doc(nftId.nftid);
        //console.log(nftRef)
        nftRef.get().then((doc) => {
            if (!doc.exists) return;
            //   console.log('Document data:', doc.data());
            setNFData(doc.data());
            // console.log(NFTData);
        });
        const uid = firebase.auth().currentUser.uid;
        const purchaseref = firebase.firestore().collection ('purchases');
        purchaseref.where('uid', '==', uid).where('nftid', '==', nftId.nftid).get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // console.log(doc.data())
                setTokenId(doc.data().tokenid)
                setDocId(doc.data()._id)
                localStorage.setItem('nftdata',JSON.stringify(doc.data().nft))
            })
        })
        const id_path = "RM0Zp6dGXBigrrG5jzc3";
        const tokenid = firebase.firestore().collection("auctionid").doc(id_path).get().then(function(doc) {
            if (doc.exists) {
                //console.log("Document data:", doc.data().auction_id);
                setAuctionId(doc.data().auction_id)
                //this.setState({TokenId: doc.data().tokenid});
                //  console.log(this.state.TokenId);
                //localStorage.setItem('auctionid',JSON.stringify(doc.data().auction_id))
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
        const id_path_a = "DX0LpOEjYnAqXJcgrNYW";
        const list_id = firebase.firestore().collection("listingid").doc(id_path_a).get().then(function(doc)
        {
            if (doc.exists) {
                console.log("Document data:", doc.data().listing_id);
                setListingId(doc.data().listing_id)
                //this.setState({TokenId: doc.data().tokenid});
                //  console.log(this.state.TokenId);
                //localStorage.setItem('auctionid',JSON.stringify(doc.data().auction_id))
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
    }, []); 

    
    //console.log(typeof auction_Id)
    //const auction_id = (auctionId.auction_id + 1 ).toString();
    //console.log(auction_id, typeof auction_id)

    
    
    const [fileUrl, setFileUrl] = useState(null)
    const [formInput, updateFormInput] = useState({ price: '', name: '', description: '' })
    //const router = useRouter()
    
    function loadingPopup(value){
        // console.log(value)
        if( value == true){
            document.querySelector('.spinner-over').classList.remove('completed')
            document.querySelector('.spinner-over').classList.add('half-spinner')
            document.querySelector('.spinner').classList.add('spinner-active')
        } else {
            document.querySelector('.spinner-over').classList.remove('half-spinner')
            document.querySelector('.spinner-over').classList.add('completed')
            setTimeout(() => {
                document.querySelector('.spinner').classList.remove('spinner-active')
                }, 5000);
        }
    }
    
    const popupState = true;

    async function createMarket(wallet) {
        popupClose();
        const popupState = true;
        loadingPopup(popupState);
        const selectedWallet = wallet;
        console.log(selectedWallet)
        const updatedvalue = document.getElementById("updated_value").value;
        const name = ""+ NFTData.film_name;
        const description = ""+NFTData.description;
        const price =""+NFTData.price;
        const fileUrl =""+NFTData.nft_media_url;
        const collection =""+NFTData.collection;
        const NFTthumb = ""+NFTData.nft_thumb;
        const tokenid = tokenId;
        console.log("Collections",collection)
        if (!name || !description || !tokenid || !price || !fileUrl || !updatedvalue || !NFTthumb) return
        /* first, upload to IPFS */
        const data = JSON.stringify({
            name, price, tokenid, updatedvalue, description, NFTUrl: fileUrl, NFTthumb: NFTthumb
        })
        createSale(selectedWallet)
    }
    
    /* approving the NFT */
    async function createSale(selectedWallet) {
        const tokenid = tokenId;
        if(selectedWallet === 'metamask'){
        const web3Modal = new Web3Modal()
        const connection = await web3Modal.connect()
        const provider = new ethers.providers.Web3Provider(connection)    
        const signer = provider.getSigner()
        let contract = new ethers.Contract(nftaddress, NFT.abi, signer)
        let transaction = await contract.approve(nftmarketaddress, tokenid,{
            gasLimit: 1000000,
            gasPrice: ethers.utils.parseUnits('10', 'gwei')
        })
        await transaction.wait()
        console.log(transaction)  
        toast.success('NFT Approved ! Signing Transaction...');
    } else if (selectedWallet === 'walletconnect'){
        const connector = new WalletConnect({
            bridge: "https://bridge.walletconnect.org", // Required
            qrcodeModal: QRCodeModal,
        });
        if (!connector.connected) {
            // create new session
            connector.createSession();
            connector.on("connect", (error, payload) => {
                if (error) {
                    throw error;
                }
                // Get provided accounts and chainId
                const { accounts, chainId } = payload.params[0];
                console.log(accounts);
                const account = accounts[0];
                localStorage.setItem('wc_account',account);
               // toast.success("Please click again to pay")
            });  
        } else {
            const wcProvider = new WalletConnectProvider({
                infuraId: "23496caecbbf436fb0a618b8129f6430", // Required
              });
              //  Enable session (triggers QR Code modal)
            await wcProvider.enable();  
            const provider = new ethers.providers.Web3Provider(wcProvider);
            console.log(provider.getSigner())
            const signer = provider.getSigner();
            let contract = new ethers.Contract(nftaddress, NFT.abi, signer)
            let transaction = await contract.approve(nftmarketaddress, tokenid,{
                gasLimit: 1000000,
                gasPrice: ethers.utils.parseUnits('10', 'gwei')
            })
            await transaction.wait()
            console.log(transaction) 

            }
    }
        /* signing the transaction */
        const listing_Id = (listingId+1).toString();
        console.log(listing_Id)
        localStorage.setItem('listingid',listing_Id);
        const updated_value = document.getElementById("updated_value").value;
        const sellapi = "https://api-us-west1.tatum.io/v3/blockchain/marketplace/listing/sell";
        const selldata = {
            "chain": "ETH",
            "contractAddress": nftmarketaddress,
            "nftAddress": nftaddress,
            "seller": walletaddress,
            "listingId": listing_Id,
            "tokenId": tokenid,
            "price": updated_value,
            "isErc721": true,
            "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83"
        }
        const sellresponse = await fetch(sellapi, {
            method: 'POST',
            body: JSON.stringify(selldata),
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key' : '510acc11-8d77-46c1-b871-9a46802e7c93'
            }
        })
        const selljson = await sellresponse.json()
        console.log(selljson)
        toast.success("Instant sale processing.. Please wait", {
            position: "top-center", });
        const { signatureId } = selljson;
        const {data} = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
            headers: {
                  'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
                }
            });
        const sellConfig = JSON.parse(data.serializedTransaction);
        sellConfig.from = walletaddress;
        console.log(sellConfig);
        console.log(selectedWallet)
        if(selectedWallet === 'metamask'){
        try{
            const { ethereum } = window;
            await ethereum.request({ method: "eth_requestAccounts" });
            const accounts = await ethereum.request({ method: "eth_accounts" });
            const chainId = await ethereum.request({ method: "eth_chainId" });
            sellConfig.from = accounts[0];
            sellConfig.gasPrice = "200000000";
            try {
                const res = await window.ethereum.request({
                    method: "eth_sendTransaction",
                    params: [sellConfig],
                });
                console.log(res);
                localStorage.setItem('TxId', res);
               
                async function getConfirmations(txHash) {
                    try {
                      // Instantiate web3 with HttpProvider
                      const web3 = new Web3('https://ropsten.infura.io/v3/23496caecbbf436fb0a618b8129f6430')
                  
                      // Get transaction details
                      const trx = await web3.eth.getTransaction(txHash)
                  
                      // Get current block number
                      const currentBlock = await web3.eth.getBlockNumber()
                  
                      // When transaction is unconfirmed, its block number is null.
                      // In this case we return 0 as number of confirmations
                      return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber
                    }
                    catch (error) {
                      console.log(error)
                    }
                  }
            
                function confirmEtherTransaction(txHash, confirmations = 3) {
                    setTimeout(async () => {
                      
                      // Get current number of confirmations and compare it with sought-for value
                      const trxConfirmations = await getConfirmations(txHash)
                      
                      console.log('Transaction with hash ' + txHash + ' has ' + trxConfirmations + ' confirmation(s)')
                  
                      if (trxConfirmations >= confirmations) {
                        // Handle confirmation event according to your business logic
                        
                        console.log('Transaction with hash ' + txHash + ' has been successfully confirmed')
                        instantlistdb();
                      }
                      // Recursive call
                      return confirmEtherTransaction(txHash, confirmations)
                    }, 30 * 1000)
                  }

                  confirmEtherTransaction(res);
               
                toast.success("NFT Listed on Sale", {
                    position: "top-center", });
                } catch (error) {
                    toast.error("Payment Failed");
                }
            }
            catch (error) {
                console.log(error);
                toast.error("Please enable Metamask", {
                    position: "top-center", });
                }
            } else if(selectedWallet === "walletconnect"){
            
                const connector = new WalletConnect({
                bridge: "https://bridge.walletconnect.org", // Required
                qrcodeModal: QRCodeModal,
            });
            if (!connector.connected) {
                // create new session
                connector.createSession();
                connector.on("connect", (error, payload) => {
                    if (error) {
                        throw error;
                    }
                    // Get provided accounts and chainId
                    const { accounts, chainId } = payload.params[0];
                    console.log(accounts);
                    const account = accounts[0];
                    localStorage.setItem('wc_account',account);
                   // toast.success("Please click again to pay")
                });  
            } else {
                
                sellConfig.from = walletaddress;
                connector.sendTransaction(sellConfig).then((result) => {
                // Returns transaction id (hash)
                toast.success("NFT Approved", {
                    position: "top-center", });
                console.log(result);
                async function getConfirmations(txHash) {
                    try {
                      // Instantiate web3 with HttpProvider
                      const web3 = new Web3('https://ropsten.infura.io/v3/23496caecbbf436fb0a618b8129f6430')
                  
                      // Get transaction details
                      const trx = await web3.eth.getTransaction(txHash)
                  
                      // Get current block number
                      const currentBlock = await web3.eth.getBlockNumber()
                  
                      // When transaction is unconfirmed, its block number is null.
                      // In this case we return 0 as number of confirmations
                      return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber
                    }
                    catch (error) {
                      console.log(error)
                    }
                  }
            
                function confirmEtherTransaction(txHash, confirmations = 3) {
                    setTimeout(async () => {
                      
                      // Get current number of confirmations and compare it with sought-for value
                      const trxConfirmations = await getConfirmations(txHash)
                      
                      console.log('Transaction with hash ' + txHash + ' has ' + trxConfirmations + ' confirmation(s)')
                  
                      if (trxConfirmations >= confirmations) {
                        // Handle confirmation event according to your business logic
                        
                        console.log('Transaction with hash ' + txHash + ' has been successfully confirmed')
                        instantlistdb();
                      }
                      // Recursive call
                      return confirmEtherTransaction(txHash, confirmations)
                    }, 30 * 1000)
                  }

                  confirmEtherTransaction(result);
                // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                }) .catch((error) => {
                    // Error returned when rejected
                    toast.error("Transaction Rejected")
                                        console.error(error);
                                      }); 
    
                }
            }
    }
    
    /* Instant List db */
    
    async function instantlistdb() {
        /* Incrementing Listing Id */
        const id_path_a = "DX0LpOEjYnAqXJcgrNYW";
        const list_token = firebase.firestore().collection("listingid").doc(id_path_a).update(
            {
                listing_id : firebase.firestore.FieldValue.increment(1),
            })
            .then(function(docRef) {
                console.log("Listing Id updated");
            }
            )
            .catch(function(error) {
                console.error("Error incrementing Listing Id ", error);
            }
            );
        /* Storing the db */
        const db = firebase.firestore();
        const user = firebase.auth().currentUser;
        // const userUid = getAuth().currentUser.uid;
        const transhash = localStorage.getItem('TxId')
        const from = walletaddress;
        const nftdata = JSON.parse(localStorage.getItem('nftdata'));
        //console.log(nftdata)
        //localStorage.setItem('walletaddress',from);
        db.collection('metadata').add({
            nft: nftdata,
            transhash: transhash,
            TokenID: tokenId,
            listingId: listingId,
            fromaddress: from,
            collection:""+NFTData.collection,
            description: ""+NFTData.description,
            NFTUrl: ""+NFTData.nft_media_url,
            NFTName: ""+ NFTData.nft_title,
            NFTUpdatedPrice: document.getElementById("updated_value").value,
            NFTthumb: ""+NFTData.nft_thumb,
            OnAuction: false,
            listingDate: new Date(),
        })
        .then(function(docRef) {
            // console.log("Document written with ID: ", docRef.id);
            window.location.href = "/profile";

        })
        .catch(function(error) {
            toast.error('Something Went Wrong');
            const closeLoading = !popupState
            loadingPopup(closeLoading);
            console.error("Error adding document: ", error);
        });
    const purchaseref = firebase.firestore().collection ('purchases');
    purchaseref.doc(docId).delete().then(
        () => {
            console.log("Document deleted")
            const closeLoading = !popupState
            loadingPopup(closeLoading);
        })
        .catch((error) => console.error("Error deleting document", error));
    }
    
    function checkWallet(){
        if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
            //alert("No Value")
            alert('Redirecting to Wallet Page...Please Connect Wallet to Proceed');
            const currentUrl = window.location.pathname;
            localStorage.setItem('currentUrl', currentUrl);
            window.location.href ="../../../Wallet/";
        } else {
            handlePopup();
        }
    }

    async function createAuction(wallet){
        
        popupClose();
        auctionPopupClose()
        const popupState = true;
        loadingPopup(popupState);
        const selectedWallet = wallet;
        console.log(selectedWallet)
        const auction_price = document.getElementById("auction_price").value;
        const auction_time = document.getElementById("auction_time").value;
        //console.log(auction_price)
        //console.log(auction_time)
        var date = new Date();
        // alert(date);
        var last = new Date(date.getTime() + (auction_time * 24 * 60 * 60 * 1000));
        var last_date = last.getFullYear() + '-' + (last.getMonth() + 1) + '-' + last.getDate();
        var last_time = last.getHours() + ':' + last.getMinutes() + ':' + last.getSeconds();
        var last_date_time = last_date + ' ' + last_time;
        var last_date_time = new Date(last_date_time);
        // alert(last_date_time);
        var iso_date_time = last_date_time.toISOString();
        localStorage.setItem('end_date_time', iso_date_time);
        // alert(iso_date_time);
        const timeapi = "https://api-us-west1.tatum.io/v3/blockchain/auction/time/ETH/"+iso_date_time;
        const timeapi_response = await fetch(timeapi, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key' : '510acc11-8d77-46c1-b871-9a46802e7c93'
            }
        });       
        const lastBlock = await timeapi_response.json();
        console.log(lastBlock)
        localStorage.setItem('lastBlock',lastBlock);
        const approvalapi = "https://api-us-west1.tatum.io/v3/blockchain/auction/approve";
        const approvalapi_response = await fetch(approvalapi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key' : '510acc11-8d77-46c1-b871-9a46802e7c93'
            },
            body: JSON.stringify({
                "chain": "ETH",
                "contractAddress": nftaddress,
                "spender": "0xea1ad7504135ab86eed9a5ef8efcde6f1f6b012c",
                "isErc721": true,
                "tokenId": tokenId,
                "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83",
                "index": 0,
                "fee": {
                    "gasLimit": "400000",
                    "gasPrice": "40"
                }
            })
        });
        const approvalapi_json = await approvalapi_response.json();
        console.log(approvalapi_json)
        toast.success("Approval processing.. Please wait", {
                    position: "top-center", });
        const { signatureId } = approvalapi_json;
        const {data} = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
            headers: {
                'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
            }
        });
        const txConfig = JSON.parse(data.serializedTransaction);
        txConfig.from = walletaddress; 
        console.log(txConfig);
        if( selectedWallet === "metamask"){
            try{
                const { ethereum } = window;
                await ethereum.request({ method: "eth_requestAccounts" });
                const accounts = await ethereum.request({ method: "eth_accounts" });
                const chainId = await ethereum.request({ method: "eth_chainId" });
                txConfig.from = accounts[0];
                txConfig.gasPrice = "200000000";
                try {
                    const result = await window.ethereum.request({
                        method: "eth_sendTransaction",
                        params: [txConfig],
                    });
                    console.log(result);
                    toast.success("NFT Approved", {
                                position: "top-center", });
                } catch (error) {
                    toast.error("Payment Failed");
                }
            } catch (error) {
                console.log(error);
                toast.error("Please enable Metamask", {
                    position: "top-center", });
                }
        } else if(selectedWallet === "walletconnect"){
            
            const connector = new WalletConnect({
            bridge: "https://bridge.walletconnect.org", // Required
            qrcodeModal: QRCodeModal,
        });
        if (!connector.connected) {
            // create new session
            connector.createSession();
            connector.on("connect", (error, payload) => {
                if (error) {
                    throw error;
                }
                // Get provided accounts and chainId
                const { accounts, chainId } = payload.params[0];
                console.log(accounts);
                const account = accounts[0];
                localStorage.setItem('wc_account',account);
                toast.success("Please click again to pay")
            });  
        } else {
            
            txConfig.from = walletaddress;
            connector.sendTransaction(txConfig).then((result) => {
            // Returns transaction id (hash)
            toast.success("NFT Approved", {
                position: "top-center", });
            console.log(result);
            // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
            //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
            }) .catch((error) => {
                // Error returned when rejected
                toast.error("Transaction Rejected")
                                    console.error(error);
                                  }); 

            }
        }
        
        const auction_Id = (auctionId+1).toString();
        console.log(auction_Id)
        localStorage.setItem('auctionid',auction_Id);
        // console.log('auction id',auctionId);
        const price = Web3.utils.toWei(auction_price, 'ether');
        const sellapi = "https://api-us-west1.tatum.io/v3/blockchain/auction/sell";
        const sellapi_response = await fetch(sellapi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key' : '510acc11-8d77-46c1-b871-9a46802e7c93'
            },
            body: JSON.stringify({
                "chain": "ETH",
                "contractAddress": "0xEA1aD7504135Ab86eED9A5eF8EFCDe6F1F6b012c",
                "nftAddress": nftaddress,
                "seller": walletaddress,
                "id": auction_Id,
                "amount": price,
                "tokenId": tokenId,
                "endedAt": lastBlock,
                "isErc721": true,
                "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83",
                "index": 0,
                "fee": {
                    "gasLimit": "400000",
                    "gasPrice": "40"
                }
            })
        });
        const sellapi_json = await sellapi_response.json();
        console.log("sell signId", sellapi_json)
        toast.success("Processing Auction.. Please wait", {
                                position: "top-center", });
        setTimeout(()=> {sellAsset(sellapi_json, selectedWallet)} , 50000);
    }
            
    async function sellAsset(sellapi_json, selectedWallet){
        const { signatureId } = sellapi_json;
        const { data } = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
            headers: {
                'x-api-key': '510acc11-8d77-46c1-b871-9a46802e7c93'
            }
        });
        const selltxConfig = JSON.parse(data.serializedTransaction);
        console.log(selltxConfig);
        selltxConfig.from = walletaddress;
        if( selectedWallet === "metamask"){
            try{
                const { ethereum } = window;
                await ethereum.request({ method: "eth_requestAccounts" });
                const accounts = await ethereum.request({ method: "eth_accounts" });
                const chainId = await ethereum.request({ method: "eth_chainId" });
                selltxConfig.from = accounts[0];
                selltxConfig.gasPrice = "2000000000";
                try {
                    const sellResult = await window.ethereum.request({
                        method: "eth_sendTransaction",
                        params: [selltxConfig],
                    });
                    console.log('Sell Result', sellResult);
                    confirmEtherTransaction(sellResult);
                    toast.success("NFT Approved", {
                        position: "top-center", });
                    } catch (error) {
                        toast.error("Payment Failed");
                    }
                }
                catch (error) {
                    console.log(error);
                    toast.error("Please enable Metamask", {
                        position: "top-center", });
                    }       
                } else if(selectedWallet === "walletconnect"){
                    const connector = new WalletConnect({
                    bridge: "https://bridge.walletconnect.org", // Required
                    qrcodeModal: QRCodeModal,
                });
                if (!connector.connected) {
                    // create new session
                    connector.createSession();
                    connector.on("connect", (error, payload) => {
                        if (error) {
                            throw error;
                        }
                        // Get provided accounts and chainId
                        const { accounts, chainId } = payload.params[0];
                        const account = accounts[0]
                        console.log(account);
                        localStorage.setItem('wc_address', account);
                        toast.success("Please click again to pay")
                    });  
                }
                else {
                    selltxConfig.from = walletaddress;
                    connector.sendTransaction(selltxConfig).then((sellResult) => {
                        // Returns transaction id (hash)
                        toast.success("Transaction submitted to the blockchain, Please wait")
                        console.log('sellresult',sellResult);
                        confirmEtherTransaction(sellResult);
                        // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                        //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                    })
                    .catch((error) => {
                        // Error returned when rejected
                        toast.error("Transaction Rejected")
                        console.error('sell error',error);
                    }); 
                }
                
            }
    }

    async function getConfirmations(txHash) {
        try {
          // Instantiate web3 with HttpProvider
          const web3 = new Web3('https://ropsten.infura.io/v3/23496caecbbf436fb0a618b8129f6430')
      
          // Get transaction details
          const trx = await web3.eth.getTransaction(txHash)
      
          // Get current block number
          const currentBlock = await web3.eth.getBlockNumber()
      
          // When transaction is unconfirmed, its block number is null.
          // In this case we return 0 as number of confirmations
          return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber
        }
        catch (error) {
          console.log(error)
        }
      }

    function confirmEtherTransaction(txHash, confirmations = 3) {
        setTimeout(async () => {
          
          // Get current number of confirmations and compare it with sought-for value
          const trxConfirmations = await getConfirmations(txHash)
          
          console.log('Transaction with hash ' + txHash + ' has ' + trxConfirmations + ' confirmation(s)')
      
          if (trxConfirmations >= confirmations) {
            // Handle confirmation event according to your business logic
            
            console.log('Transaction with hash ' + txHash + ' has been successfully confirmed')
            storedata(txHash);
          }
          // Recursive call
          return confirmEtherTransaction(txHash, confirmations)
        }, 30 * 1000)
      }
    
    async function storedata(tx){
        console.log(tx);
        /* Incrementing Auction Id */
        const id_path = "RM0Zp6dGXBigrrG5jzc3";
        const token = firebase.firestore().collection("auctionid").doc(id_path).update(
            {
                auction_id : firebase.firestore.FieldValue.increment(1),
            })
            .then(function(docRef) {
                console.log("Auction Id updated");
            }
            )
            .catch(function(error) {
                console.error("Error incrementing Auction Id ", error);
            }
            );
            /* Storing the db */
            const auctionId = localStorage.getItem('auctionid');
            console.log('id for storing', auctionId);
            const db = firebase.firestore();
            const user = firebase.auth().currentUser;
            const tokenid = tokenId;
            const nftdata = JSON.parse(localStorage.getItem('nftdata'));
            const transhash = tx;
            const endDateTime = localStorage.getItem('end_date_time');
            console.log('end date time', endDateTime);
            db.collection('metadata').add({
                nft: nftdata,
                transhash: transhash,
                TokenID: tokenid,
                fromaddress: walletaddress,
                NFTUpdatedPrice: document.getElementById('auction_price').value,
                OnAuction: true,
                AuctionId: auctionId,
                auctionDuration: endDateTime,
            })
            .then(function(docRef) {
                console.log("Document written with ID: ", docRef.id);
                toast.success('Data Saved Successfully');
            })
            .catch(function(error) {
                toast.error('Something Went Wrong');
                const closeLoading = !popupState
                loadingPopup(closeLoading);
                console.error("Error adding document: ", error);
            });
            const purchaseref = firebase.firestore().collection ('purchases');
            purchaseref.doc(docId).delete().then(
                () => {
                    console.log("Document deleted")
                    const closeLoading = !popupState
                    loadingPopup(closeLoading);
                    window.location.href = '/profile';
                })
                .catch((error) => console.error("Error deleting document", error));
    }
    
    function handlePopup(){
        document.querySelector(".lottery-pop-container").classList.add("popup-active");
    }
    function popupClose(){
        document.querySelector(".lottery-pop-container").classList.remove("popup-active");
    }
    function auctionPopup(){
        document.querySelector(".auction-pop-container").classList.add("auction-popup-active");
    }
    function auctionPopupClose(){
        document.querySelector(".auction-pop-container").classList.remove("auction-popup-active");
    }
    //console.log(NFTData);
            
            
            


            return(
            
            <>
             <div className="spinner">
                <span>Processing...</span>
                <div className="spinner-over half-spinner"></div>
            </div>

            {/* Pop Up Code */}
            
            <div className="lottery-pop-container">
                <div className='lottery-pop-card' style={{height: '500px'}}>
                    <div className="lottery-pop-close"><span  onClick={popupClose}>X</span></div>
                    <h3>Put To Sale</h3>
                    <p>You're about to Sell the NFT</p>
                    <div className="row">
                        <div class="col-md-12">
                            <p>Enter the price</p>
                            <input type="text" id="updated_value" className="bid-value" style={{color: 'white'}}/>
                        </div>
                    </div>  
                    <div className="row" style={{paddingTop: '10px'}}>
                        <div className="col-md-12">
                            <div className="wallet-selector-dropdown">
                                <span>Sell Instantly</span>
                                <div className="wallet-selector-dropdown-content">
                                    <p onClick={()=>{createMarket('walletconnect')}} className="wallet-select-item">Wallet Connect</p> 
                                    <p onClick={()=>{createMarket('metamask')}} className="wallet-select-item">Metamask</p>
                                    </div>
                            </div>
                        
                        <h3  className='sale-seperator' style={{textAlign : "center"}}> Or </h3>
                        <button className="bbn632-hover bn28" style={{width: "100%"}} onClick={auctionPopup} >Create Auction</button>
                        </div>
                    </div>                 
                </div>
            </div>

            { /* Auction Pop Up Code */}

            <div className="auction-pop-container">
            <div className='lottery-pop-card' style={{height: '500px'}}>
                    <div className="lottery-pop-close"><span  onClick={auctionPopupClose}>X</span></div>
                    <h3>Create Auction</h3>
                    <div className="row">
                        <div class="col-md-12">
                            <p>Enter the price</p>
                            <input type="text" required id="auction_price" className="bid-value" style={{color: 'white'}}/>
                            <p>Enter the number of days</p>
                            <input type="text" required id="auction_time" className="bid-value" style={{color: 'white'}}/>
                        </div>
                    </div>  
                    <div className="row" style={{paddingTop: '10px'}}>
                        <div className="col-md-12">
                        <div className="wallet-selector-dropdown">
                                <span>Create Auction</span>
                                <div className="wallet-selector-dropdown-content">
                                    <p onClick ={()=>createAuction('walletconnect')} className="wallet-select-item">Wallet Connect</p> 
                                    <p onClick ={()=>createAuction('metamask')} className="wallet-select-item">Metamask</p>
                                    </div>
                            </div>
                        </div>
                    </div>                 
                </div>
            </div>

                <div className="container-fluid">
                  <div className="row" >
                      <div className="nft-final-video">
                        <center> 
                        <iframe src={NFTData.nft_media_url} className="nft-video" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        
                       
                         </center>
                         <div className="vdo-btnn-full">
                   
                     
                   <button  className="vdo-btnn" onClick="#">
       <span className="glyphicon glyphicon-heart-empty"></span> Like {}
      </button>

                <button  className="vdo-btnn2">
                <span className="glyphicon glyphicon-share"></span> 
                <ShareButton buttonStyle={divStyle}/> </button>
               </div>
                        
                      </div>
                      <div>
                      
                      </div>
                  </div>
              </div>
      
              <div className="Loran-title-full">
          
                  <div className="">
                      <div className="set-1">
      
                          <div className="loran-left">
                              <h1 className="loran-ti">{NFTData.film_name}</h1>
                              <button className="rounded-pill" id="legentry">{NFTData.collection}</button>
      
                              <br></br>
                              <br></br>
      
                              <h2 className="disc">DESCRIPTION</h2>
                              <div className="lorem-para">
                                  <p>{NFTData.about}</p>
                              </div>
                          </div>
      
                      </div>
                      <div className="set-1">
                          <div className="loran-right">                       
                              <div className="tabb-box">
                                  <div className="current-bid">
                                      <div className="current-bid-text-1">
      
                                          <h3 className="current-bid-text-heading">Last Bid Value</h3>
                                          <h1 className="current-bid-price">{NFTData.price} MAT</h1>
                                          <h5 className="current-bid-price-small">607 Matic Reserved Price</h5>
                                      </div>
                                  </div>
                                  <div className="final-verti-line"></div>
                                  <div>
      
                                  <div className="current-bid2">
                                      <div className="current-bid-text-1">
                                          <h3  className="current-bid-text-heading">Auction ending in</h3>
                                          <h1   className="current-bid-price">-- -- --</h1>
                                          <h5 className="date-time">  Days     Hours      Mins</h5>
                                      </div>
                                      </div>
      
                                  </div>
                                  <hr className="final-box-hr"></hr>
                     <button className="bbn632-hover bn28" onClick={()=> {checkWallet()}}  id="place-a-bid">Put to Sale</button>       
                              </div> 
                              <div className="purchase-box">
                                <div>
                                <h3 className="current-bid-text-heading">Last Bid Value</h3>
                                <h1 className="current-bid-price">{NFTData.price} MAT</h1>
                                <h5 className="current-bid-price-small">607 Matic Reserved Price</h5>
                                </div>
                                <div>
                                <h3  className="current-bid-text-heading">Auction ends in</h3>
                                <h1   className="current-bid-price">-- -- --</h1>
                                <h5 className="date-time">  Days      Hours      Mins</h5>
                                </div>
                                <div>
                                <button className="bbn632-hover bn28" onClick={handlePopup}   id="place-a-bid">Put to Sale</button>
                                </div>
                                </div>                        
      
                              <div className="exclusive">
                              <div className="rewards-dropdown">
  <button className="exclusive-bt">EXCLUSIVE REWARDS AVAILABLE  <span class="glyphicon glyphicon-menu-down" aria-hidden="true" id="drop-down"></span> </button>
  <div className="dropdown-content" style={{'borderRadius':'50px'}}>
    <center> 
  <h4 style={{ color: 'white' }}>{NFTData.exclusive}</h4>
  </center>
  </div>
</div>  
                              </div>
      
      
      
                          </div>
                      </div>
                      
                  </div>
                  <br></br>
                  <br></br>  <br></br>
                  <br></br>
                  <br></br>  <br></br>
      
                  {/* DETAILS */}
      
                  <div className="final-details final-details-sale">
                      <div>
                          <p className="disc">DETAILS</p>
      
                          <div className="final-boxx">
                              <p className="ctnt">10 of {NFTData.quantity} NFTs remaining</p>
                          </div>
                          <br></br>
                          <div className="final-boxx">
                              <p className="ctnt1">Blockchain <span className="content-shad">Polygon</span> </p>
                          </div>
      
      
                      </div>
      
                      <div className="final-properties-full" >
                          <div className="final-properties">
                              <p className="final-properties-head">PROPERTIES</p>
                          </div>
                          <div></div>
                          <div className="final-properties-boxx">
                              <div className="final-properties-box">
                                  <p className="final-properties-box-text">Category</p>
                                  <p className="final-properties-box-text1">{NFTData.category}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p className="final-properties-box-text-framerate">Movie</p>
                                  <p className="final-properties-box-text1-24">{NFTData.film_name}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p className="final-properties-box-text-framerate"> Celebrity</p>
                                  <p className="final-properties-box-text1-24">{NFTData.celebrity}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p className="final-properties-box-text-framerate">Production</p>
                                  <p className="final-properties-box-text1-purple">{NFTData.production_house}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p className="final-properties-box-text">Rarity</p>
                                  <p className="final-properties-box-text1">{NFTData.rarity}</p>
      
                              </div>
      
                          </div>
      
                      </div>
                     
                  </div>
      
              </div>
      
            
      
             
              <div>
      
                
              </div>
              <Fotter/>
         
            
     
            </>
          );
         
  }

  
     
  
 

 